<template>
    <div class="change-modal-gift-vouchers alert alert-info">
        <button class="btn btn-default change-modal-gift-vouchers__print-btn"
                @click.prevent="printSoldGiftVouchers()">
            <i class="fa-solid fa-print"></i>
        </button>

        <h3>{{ l('CHANGE_MODAL.GIFT_VOUCHERS_HEADING') }}</h3>

        <ChangeModalGiftVoucher v-for="voucher in vouchers"
                                :key="voucher.ID"
                                :voucher="voucher" />
    </div>
</template>

<script>
import ChangeModalGiftVoucher from '@/epos/vue/modals/Change/ChangeModalGiftVoucher';
import { container } from '@/container';

export default {
    components: { ChangeModalGiftVoucher },

    props: {
        vouchers: {
            type: Array,
            required: true,
        },
    },

    methods: {
        printSoldGiftVouchers() {
            container.receiptPrinter.printGiftVouchers(this.vouchers);
        },
    },
};
</script>

<style lang="less">
@import (less, reference) "../../../../less/variables.less";

.change-modal-gift-vouchers {
    position: relative;
    margin: @gutter-width 0 0;

    &__print-btn {
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 0;
        height: 40px;
        width: 50px;
        top: @half-gutter-width;
        right: @gutter-width;
    }

    h3 {
        margin: 0 0 @gutter-width 0;
    }
}
</style>
